export const getFixedAmount = (flowConfigFixedAmount) => {
  let finalAmount = null;
  if (flowConfigFixedAmount) {
    let amount = parseInt(flowConfigFixedAmount);
    if (!isNaN(amount)) {
      finalAmount = amount;
    }
  }
  return finalAmount;
};
